import Image from 'next/image';

import type { IForYouItem } from '../../types';

export const ForYou = ({ items }: { items: IForYouItem[] }) => {
	return (
		<>
			<div className="-m-3 flex snap-x snap-mandatory flex-nowrap gap-4 overflow-x-auto p-3 xl:m-0 xl:grid xl:snap-none xl:grid-cols-3 xl:gap-4 xl:overflow-visible xl:p-0">
				{items.map((item, key) => (
					<div
						key={key}
						className="flex w-10/12 shrink-0 snap-center flex-col gap-4 rounded-2xl border border-[#DBDFE9] bg-white p-4 max-xl:max-w-md xl:w-auto xl:gap-6 xl:rounded-3xl xl:p-6 2xl:gap-8 2xl:rounded-[40px] 2xl:p-8"
					>
						<Image
							src={item.image}
							alt={item.imageAlt}
							width={533}
							loading="lazy"
							height={227}
							className="h-[227px] w-[260px] object-contain xl:h-[227px] xl:w-[410px] 2xl:h-[227px] 2xl:w-[533px]"
						/>
						<p className="text-sm/[1.2] font-semibold text-[#252F4A] xl:text-base/[1.2] 2xl:text-2xl/[1.3]">
							{item.content}
						</p>
					</div>
				))}
			</div>
		</>
	);
};
